import { faCircle, faMeh } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { FeedbackRating } from '@citruscamps/citrus-client'
import { FeedbackRatingDetails, FeedbackRatingTypes } from '../../utils/feedback'

interface IProps extends React.HTMLAttributes<HTMLSpanElement> {
  rating?: FeedbackRating
}

export const FeedbackRatingIcon = ({ rating, ...props }: IProps) => {
  const r: FeedbackRatingDetails | undefined =
    rating && FeedbackRatingTypes.find((i) => i.id === rating)
  return (
    <span {...props}>
      <span className="fa-layers">
        <FontAwesomeIcon icon={faCircle} className="text-dark" transform="shrink-1" />
        <FontAwesomeIcon icon={r?.icon || faMeh} className={r?.id || 'text-gray'} />
      </span>
    </span>
  )
}
